import DesktopLayout from '../../components/layout/DesktopLayout';
import MemberDashboard from '../../components/member/MemberDashboard';
import type { DashboardTab } from '../../components/member/MemberDashboard';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './MemberDashboardPage.css';

const MemberDashboardPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<DashboardTab>('overview');

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam === 'overview' || tabParam === 'analytics' || tabParam === 'settings') {
      setActiveTab(tabParam);
    } else {
      setActiveTab('overview');
    }
  }, [searchParams]);

  const handleTabChange = (tab: DashboardTab) => {
    setSearchParams({ tab });
  };

  const getTabTitle = (): string => {
    switch (activeTab) {
      case 'settings':
        return '帳號設定';
      case 'analytics':
        return '數據分析';
      default:
        return '會員中心';
    }
  };

  return (
    <div className="member-dashboard-page">
      <DesktopLayout>
        <main className="member-dashboard-page__main">
          <div className="member-dashboard-page__container">
            {/* Navigation Menu */}
            <nav className="member-dashboard-page__nav">
              <button
                className={`member-dashboard-page__nav-item ${activeTab === 'overview' ? 'member-dashboard-page__nav-item--active' : ''}`}
                onClick={() => handleTabChange('overview')}
              >
                概覽
              </button>
              <button
                className={`member-dashboard-page__nav-item ${activeTab === 'analytics' ? 'member-dashboard-page__nav-item--active' : ''}`}
                onClick={() => handleTabChange('analytics')}
              >
                數據分析
              </button>
              <button
                className={`member-dashboard-page__nav-item ${activeTab === 'settings' ? 'member-dashboard-page__nav-item--active' : ''}`}
                onClick={() => handleTabChange('settings')}
              >
                帳號設定
              </button>
            </nav>

            <h1 className="member-dashboard-page__title">{getTabTitle()}</h1>

            <MemberDashboard
              activeTab={activeTab}
              onTabChange={handleTabChange}
            />
          </div>
        </main>
      </DesktopLayout>
    </div>
  );
};

export default MemberDashboardPage;
